export const transactionBy = {
  cash: "Cash",
  cheque: "Cheque",
};

export const transactionType = {
  credit: "Credit",
  debit: "Debit",
};
